export function hasItems() {
  'ngInject';
  return function (obj) {
    return Object.keys(obj).some((key) => obj[key].length > 0);
  };
}
